/*
 * @Author: zhouzhuoxin
 * @Email: shzhouzhuoxin@jd.com
 * @Date: 2021-03-24 11:11:33
 * @Last Modified by: zhouzhuoxin
 * @Last Modified time: 2021-08-27 08:35:22
 * @Description:
 * 根据请求的地址和配置焕春请求返回值
 * {
 *  url + "__" + JSON.stringify({config, query}): res
 * }
 */

import _ from 'lodash';
interface ResType {
  ret: string;
  data: any;
  msg: string;
}

interface CacheItem {
  res: ResType;
}

interface RequestCacheType {
  [key: string]: CacheItem;
}

const requestCache: RequestCacheType = {};

function setCache(url: string, config: any, res: ResType) {
  if (!url) return;
  if (!res) return;
  if (res.ret !== '0') return;

  requestCache[url + '__' + JSON.stringify(config)] = { res };
}

function getCache(url: string, config: any) {
  if (!requestCache[url + '__' + JSON.stringify(config)]) return;
  try {
    return _.cloneDeep(requestCache[url + '__' + JSON.stringify(config)].res);
  } catch (ex) {}
}

// function clearCache() {}

export { setCache, getCache };
